module.exports = __webpack_public_path__ + "img/2-2.a0a036e4.svg";